// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2Feju","legacyBtn":"MutateMid_legacyBtn__1W8FL"};